<main>
    <app-sidebar></app-sidebar>
    <app-header></app-header>
    <router-outlet></router-outlet>
</main>
